export enum StepContainerAction {
	NEXT,
	PREV,
	SAVE,
	DOSSIER_NEXT,
}
